import React from 'react';
import PropTypes from 'prop-types';

const Info = ({ className, color }) => (
    <svg
        className={className}
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 4C7.58211 4 4 7.58211 4 12C4 16.4179 7.58211 20 12 20C16.4179 20 20 16.4179 20 12C20 7.58211 16.4179 4 12 4ZM12 2C6.47754 2 2 6.47754 2 12C2 17.5225 6.47754 22 12 22C17.5225 22 22 17.5225 22 12C22 6.47754 17.5225 2 12 2ZM10.2425 12.4701L11 12.2808V15H10C9.44771 15 9 15.4477 9 16C9 16.5523 9.44771 17 10 17L12 17L14 17C14.5523 17 15 16.5523 15 16C15 15.4477 14.5523 15 14 15H13V11.0224C13.001 10.9746 12.9986 10.9263 12.9926 10.8778C12.9783 10.7602 12.9435 10.6488 12.892 10.5474C12.8246 10.4143 12.7293 10.3005 12.6154 10.2118C12.4114 10.0527 12.1477 9.97383 11.8778 10.0074C11.8293 10.0133 11.7818 10.0227 11.7357 10.0353L9.75746 10.5299C9.22167 10.6638 8.89591 11.2067 9.02986 11.7425C9.16381 12.2783 9.70674 12.6041 10.2425 12.4701ZM12.0002 9.33789C12.739 9.33789 13.3379 8.73897 13.3379 8.00017C13.3379 7.26137 12.739 6.66245 12.0002 6.66245C11.2614 6.66245 10.6624 7.26137 10.6624 8.00017C10.6624 8.73897 11.2614 9.33789 12.0002 9.33789Z"
            fill={color}
        />
    </svg>
);

Info.propTypes = {
    className: PropTypes.string,
    color: PropTypes.string,
};

Info.defaultProps = {
    className: '',
    color: '#333333',
};

export default Info;
